import {
	ArticleWrapper,
	DateWrapper,
	ArticleImage,
	TextSpan,
	Square,
	DescriptionText,
	ArticleBottom,
	H2,
} from "./Article.styles";
import React from "react";
import { MockButton } from "Components/Video";

export const Article = (article) => {
	const { Url, Heading, Description, Image, DocumentType, fullWidth } = article;
	let isVideo = DocumentType === "Video";
	return (
		<ArticleWrapper href={Url} fullWidth={fullWidth}>
			<ArticleImage fullWidth={fullWidth} Image={Image}>
				{isVideo && (
					<MockButton>
						<i className="icon-play"></i>
					</MockButton>
				)}
			</ArticleImage>
			<ArticleBottom>
				<DateWrapper>
					<TextSpan>
						<Square />
						{DocumentType}
					</TextSpan>
				</DateWrapper>
				<H2 color="black">
					<span>{Heading}</span>
				</H2>
				<DescriptionText fullWidth={fullWidth}>{Description}</DescriptionText>
			</ArticleBottom>
		</ArticleWrapper>
	);
};
